import encoding from 'encoding-japanese';

import cmnConst from '@/lib/cmnConst';
import func from '@/lib/func';

export default {
  makeCsv(game) {
    const ret = [];
    const header = [
      `${game.gameInfo.player1Name}:ポイント`,
      `${game.gameInfo.player2Name}:ポイント`,
      `${game.gameInfo.player1Name}:ゲーム`,
      `${game.gameInfo.player2Name}:ゲーム`,
      'ラリー本数',
    ];
    ret.push(header.join(','));
    let info = {
      p1: 0,
      p2: 0,
      s1: 0,
      s2: 0,
    };
    for (let i = 0; i < game.points.length; i++) {
      const line = [];
      info = func.nextPoint(info, game.points[i]);
      line.push(info.p1);
      line.push(info.p2);
      line.push(info.s1);
      line.push(info.s2);
      line.push(game.labels[i]);
      ret.push(line.join(','));
    }
    return ret.join('\n');
  },
  makeCsvDetail(game) {
    const ret = [];
    let info = {
      p1: 0,
      p2: 0,
      s1: 0,
      s2: 0,
    };
    for (let i = 0; i < game.points.length; i++) {
      info = func.nextPoint(info, game.points[i]);
      const block = [];
      block.push(`${info.p1} - ${info.p2}`);
      block.push(this.getRallyCntLine(game.hitsList[i].isServe));
      block.push(this.getHitPlayerLine(game.hitsList[i].player,
        game.gameInfo.player1Name,
        game.gameInfo.player2Name));
      block.push(this.getHitPositionLine(game.hitsList[i].hitPosition,
        game.hitsList[i].isServe));
      block.push(this.getHitHandLine(game.hitsList[i].hand));
      block.push(this.getHitStyleLine(game.hitsList[i].hitStyle,
        game.hitsList[i].isServe));
      block.push(this.getCourseLine(game.hitsList[i].course));
      block.push(this.getInOutLine(game.hitsList[i].inOut));
      block.push(this.getOtherLine(game.hitsList[i].inOut,
        game.hitsList[i].inOutDetail));
      ret.push(block.join('\n'));
    }
    return ret.join('\n\n');
  },
  makeMemo(game) {
    return game.gameInfo.memo;
  },
  getOtherLine(inOutArr, inOutDetailArr) {
    const ret = [];
    ret.push('インorアウト詳細');
    for (let i = 0; i < inOutArr.length; i++) {
      if (inOutArr[i]) {
        ret.push(cmnConst.inList[inOutDetailArr[i]]);
      } else {
        ret.push(cmnConst.outList[inOutDetailArr[i]]);
      }
    }
    return ret.join(',');
  },
  getInOutLine(inOutArr) {
    const ret = [];
    ret.push('インorアウト');
    inOutArr.forEach((x) => {
      if (x) {
        ret.push(cmnConst.courseList[0]);
      } else {
        ret.push(cmnConst.courseList[1]);
      }
    });
    return ret.join(',');
  },
  getCourseLine(courseArr) {
    const ret = [];
    ret.push('コース');
    courseArr.forEach((x) => {
      ret.push(cmnConst.courseList[x]);
    });
    return ret.join(',');
  },
  getHitStyleLine(hitStyleArr, isServeArr) {
    const ret = [];
    ret.push('打法');
    for (let i = 0; i < hitStyleArr.length; i++) {
      if (isServeArr[i]) {
        ret.push(cmnConst.serveList[hitStyleArr[i]]);
      } else {
        ret.push(cmnConst.hitsStyleList[hitStyleArr[i]]);
      }
    }
    return ret.join(',');
  },
  getHitHandLine(handArr) {
    const ret = [];
    ret.push('フォアorバック');
    for (let i = 0; i < handArr.length; i++) {
      ret.push(cmnConst.handList[handArr[i]]);
    }
    return ret.join(',');
  },
  getHitPositionLine(hitPositionArr, isServeArr) {
    const ret = [];
    ret.push('打球位置');
    for (let i = 0; i < hitPositionArr.length; i++) {
      if (isServeArr[i]) {
        ret.push(cmnConst.hitPostionAtServe[hitPositionArr[i]]);
      } else {
        ret.push(cmnConst.hitPostion[hitPositionArr[i]]);
      }
    }
    return ret.join(',');
  },
  getHitPlayerLine(playerArr, player1Name, player2Name) {
    const players = ['', player1Name, player2Name];
    const ret = [];
    ret.push('選手');
    playerArr.forEach((x) => {
      ret.push(players[x]);
    });
    return ret.join(',');
  },
  getRallyCntLine(isServeArr) {
    const ret = [];
    ret.push('ラリー回数');
    let counter = 1;
    for (let i = 0; i < isServeArr.length; i++) {
      if (!isServeArr[i]) {
        counter++;
      }
      ret.push(counter);
    }
    return ret.join(',');
  },
  export(str, fileName) {
    const strArray = encoding.stringToCode(str);
    const convertedArray = encoding.convert(strArray, 'SJIS', 'UNICODE');
    const UintArray = new Uint8Array(convertedArray);
    const blobUrl = new Blob([UintArray], { type: 'text/csv' });
    const blob = blobUrl;
    const aTag = document.createElement('a');
    aTag.download = fileName;
    if (window.navigator.msSaveBlob) {
      // for IE
      window.navigator.msSaveBlob(blob, aTag.download);
    } else if (window.URL && window.URL.createObjectURL) {
      // for Firefox
      aTag.href = window.URL.createObjectURL(blob);
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
    } else if (window.webkitURL && window.webkitURL.createObject) {
      // for Chrome
      aTag.href = (window.URL || window.webkitURL).createObjectURL(blob);
      aTag.click();
    } else {
      // for Safari
      window.open(
        `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
        '_blank',
      );
    }
  },
  exportCsv(game) {
    const fileName = game.gameInfo.matchName;
    this.export(this.makeCsv(game), `${fileName}_normal.csv`);
    this.export(this.makeCsvDetail(game), `${fileName}_detail.csv`);
    this.export(this.makeMemo(game), `${fileName}_memo.txt`);
  },
};



// WEBPACK FOOTER //
// ./src/lib/makeCsv.js